import { find, map, some } from 'lodash';

import { getErrorMessage } from 'application/util/error.util';
import analytics from 'common/analytics';
import iconMap from 'application/component/category-icon/category-icon-map.json';

import './category-edit-modal.style.sass';
import template from './category-edit-modal.tpl.pug';

class CategoryEditModalController {
    /* @ngInject */
    constructor($q, categoryService, modalService, notificationService) {
        this.$q = $q;
        this.categoryService = categoryService;
        this.modalService = modalService;
        this.notificationService = notificationService;
    }

    $onInit() {
        this.existing = !!this.category && !!this.category.id;
        this.loading = true;
        this.activeTab = 'label';

        return this.$q.all([
            this.categoryService.getAll(this.teamId),
            this.categoryService.getPalette()
        ]).then(([categories, colors]) => {
            this.colors = map(colors, (color) => {
                return {
                    used: some(categories, (category) => category.color === color),
                    hex: color
                };
            });

            this.icons = map(iconMap || [], (icon) => {
                return {
                    iconIndex: icon.iconIndex,
                    iconName: this.normalizeIconName(icon.svgFilename)
                };
            });

            this.syncCategoryIcon();
        }).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to load the color palette. Please try again later.`));
        }).finally(() => this.loading = false);
    }

    normalizeIconName(iconName) {
        if (!iconName) {
            return null;
        }

        return `${iconName}`.replace(/\.svg$/i, '');
    }

    syncCategoryIcon() {
        if (!this.category) {
            return;
        }

        const normalizedIconName = this.normalizeIconName(this.category.iconName);

        if (!this.category.iconIndex && normalizedIconName) {
            const matchedByName = find(this.icons, (icon) => icon.iconName === normalizedIconName);
            this.category.iconIndex = matchedByName ? matchedByName.iconIndex : null;
        }

        if (!this.category.iconName && this.category.iconIndex) {
            const matchedByIndex = find(this.icons, (icon) => icon.iconIndex === this.category.iconIndex);
            this.category.iconName = matchedByIndex ? matchedByIndex.iconName : null;
            return;
        }

        this.category.iconName = normalizedIconName;
    }

    selectTab(tab) {
        this.activeTab = tab;
    }

    selectIcon(icon) {
        if (!this.category || !icon) {
            return;
        }

        this.category.iconIndex = icon.iconIndex;
        this.category.iconName = icon.iconName;
    }

    updateColor(color) {
        this.color = color;
    }

    save() {
        let promise = this.existing
            ? this.categoryService.update(this.teamId, this.category)
            : this.categoryService.create(this.teamId, this.category);
        
        return promise.then((category) => {
            if (this.existing) {
                analytics.trackCategoryUpdate(this.category);
            } else {
                analytics.trackCategoryCreate(this.category, this.from);
            }

            return this.onClose({
                data: category
            });
        }).catch((result) => {
            this.notificationService.showError(getErrorMessage(result, `We were not able to save the category. Please try again later.`));
        });
    }

    remove() {
        return this.modalService.open({
            component: 'dbAConfirmModal',
            bindings: {
                title: 'Delete category',
                message: [
                    `Deleting a category cannot be undone. All the transactions which belong to this category will be uncategorized.`,
                    `Are you still sure about it?`
                ],
                onClose: () => {
                    return this.categoryService.remove(this.teamId, this.category)
                        .then(() => {
                            analytics.trackCategoryDelete(this.category);
                            return this.onClose();
                        }).catch((result) => {
                            this.notificationService.showError(getErrorMessage(result, `We were not able to delete the ${this.category.name} category. Please try again later.`));
                            return this.$q.reject(result);
                        });
                }
            }
        }).catch(() => null);
    }

    dismiss() {
        this.onDismiss();
    }
}

export default {
    selector: 'dbACategoryEditModal',
    template: template(),
    controller: CategoryEditModalController,
    bindings: {
        teamId: '<',
        category: '<',
        from: '<',
        canEdit: '<',
        canDelete: '<',
        onDismiss: '&',
        onClose: '&'
    }
};



// WEBPACK FOOTER //
// ./src/application/component/modals/component/category-edit-modal/category-edit-modal.cmpt.js